import { combineReducers } from "redux";

import { default as prompt } from "./prompt";
import { default as response } from "./response";
import { default as accountRemoval } from "./account-removal";

export default combineReducers({ prompt, response, accountRemoval });

export * from "./prompt";
export * from "./response";
export * from "./account-removal";
